module.exports = __webpack_public_path__ + "img/comoros.49234f04.png";